import {
  Button,
  CircularProgress,
  makeStyles,
  Typography,
} from '@material-ui/core';
import { useStores } from 'doc-mate-store/lib/hooks';
import qs from 'qs';
import React, { useEffect, useRef, useState } from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useHistory, useLocation } from 'react-router';

type Props = {
  autoFocus?: boolean;
  className?: string;
};

const ManifestLinkForm: React.FC<Props> = ({ autoFocus, className }) => {
  const classes = useStyles();
  const { rootStore } = useStores();
  const location = useLocation();
  const history = useHistory();
  const trackingNumberRef = useRef<TextValidator>(null);
  const search = location.search.substring(1);
  const query = qs.parse(search);
  const [trackingNumber, setTrackingNumber] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const hasTrackerError = typeof query._t !== 'undefined';

  useEffect(() => {
    ValidatorForm.addValidationRule(
      'noTrackerError',
      value => value || !hasTrackerError,
    );
    return () => {
      ValidatorForm.removeValidationRule('noTrackerError');
    };
  }, [hasTrackerError]);

  useEffect(() => {
    if (hasTrackerError && trackingNumberRef.current) {
      (trackingNumberRef.current as any).validate('');
    }
  }, [hasTrackerError]);

  function handleChange(event: any) {
    setTrackingNumber(event.target.value);
    setError(null);
  }

  async function handleSubmit() {
    setLoading(true);
    const ret = await rootStore.fetchOrderLegByBillOfLading(
      trackingNumber,
      true,
      true,
    );
    setLoading(false);
    if (ret) {
      history.push(`/l/${ret.orderLegLinkId}?show_all=True`);
    } else {
      setError('Bill of Lading is not valid.');
    }
  }

  return (
    <ValidatorForm
      className={className}
      autoComplete="off"
      onSubmit={handleSubmit}
    >
      <Typography variant="h3" component="h2" className={classes.prompt}>
        Enter the Bill Of Lading
      </Typography>
      <TextValidator
        id="manifest-number"
        ref={trackingNumberRef}
        autoFocus={autoFocus}
        error={!!error}
        helperText={error || undefined}
        size="small"
        name="trackingNumber"
        fullWidth
        onChange={handleChange}
        value={trackingNumber}
        variant="outlined"
        validators={['noTrackerError', 'required']}
        errorMessages={[
          'Bill of lading is not valid.',
          'This field is required.',
        ]}
        placeholder="123456789"
      />
      <Button
        color="primary"
        endIcon={
          loading ? <CircularProgress size={14} color="secondary" /> : undefined
        }
        fullWidth
        variant="contained"
        type="submit"
        className={classes.submit}
      >
        Track your shipment
      </Button>
    </ValidatorForm>
  );
};

const useStyles = makeStyles(theme => ({
  prompt: {
    marginBottom: theme.spacing(4),
  },
  submit: {
    marginTop: theme.spacing(4),
  },
}));

export default ManifestLinkForm;
